export { default } from './ColoredSlice';
